<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Форма заявки</h1>
      <form @submit.prevent="submitUser">
        <b-field
          label="ФИО:"
          type="is-info"
          class="big_input has_icon"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            icon="mdi mdi-account"
            placeholder="ФИО"
            v-model="form.name"
            name="name"
            v-validate="{ required: true, min: 2, max: 62 }"
          ></b-input>
        </b-field>
        <b-field
          label="Район:"
          type="is-info"
          class="left_input has_icon"
          :message="errors.first('region')"
          :class="errors.first('region') ? 'error' : ''"
        >
          <b-input
            icon="mdi mdi-account"
            placeholder="Район"
            v-model="form.region"
            name="region"
            v-validate="{ required: false }"
          ></b-input>
        </b-field>
        <b-field
          label="Телефон:"
          type="is-info"
          class="right_input has_icon"
          :message="errors.first('phone')"
          :class="errors.first('phone') ? 'error' : ''"
        >
          <b-input
            icon="mdi mdi-account"
            placeholder="Телефон"
            v-model="form.phone"
            name="phone"
            v-validate="{ required: true, regex: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/ }"
          ></b-input>
        </b-field>
        <b-field
          label="Текст обращения:"
          type="is-info"
          class="textarea_field"
          :message="errors.first('comment')"
          :class="errors.first('comment') ? 'error' : ''"
        >
          <b-input
            name="comment"
            placeholder="Текст обращения:"
            type="textarea"
            v-model="form.comment"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          Отправить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    form: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      dict: {
        custom: {
          name: {
            required: 'Поле не заполнено',
            min: 'Слишком короткое значение',
            max: 'Слишком длинное значение'
          },
          phone: {
            required: 'Поле не заполнено',
            regex: 'Неверный формат телефона'
          },
          comment: {
            required: 'Поле не заполнено'
          }
        }
      }
    }
  },
  methods: {
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('submit')
        }
      })
    }
  },
  created() {
    this.$validator.localize('ru', this.dict)
  }
}
</script>
